import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import apiConfig from "../../config/api.config.js";
import {
  TOKEN_TYPE,
  REQUEST_HEADER_AUTH_KEY,
  ERROR_MESSAGES,
} from "../../config/api.constants.js";
import { logout } from "../../features/auth/authSlice.js";

// Create a custom base query with error handling
export const baseQuery = fetchBaseQuery({
  baseUrl: apiConfig.apiUrl,
  prepareHeaders: (headers, { getState }) => {
    // Add auth token to headers from state
    const token = getState().auth.token;
    if (token) {
      headers.set(REQUEST_HEADER_AUTH_KEY, `${TOKEN_TYPE}${token}`);
    }
    headers.set("Content-Type", "application/json");
    return headers;
  },
});

// Enhanced base query with error handling
export const enhancedBaseQuery = async (args, api, extraOptions) => {
  try {
    const result = await baseQuery(args, api, extraOptions);

    // Handle error responses
    if (result.error) {
      const { status } = result.error;

      // Handle 401 Unauthorized - log out user
      if (status === 401) {
        api.dispatch(logout());
        return { error: { status, data: ERROR_MESSAGES.UNAUTHORIZED } };
      }

      // Handle 403 Forbidden
      if (status === 403) {
        console.error(ERROR_MESSAGES.FORBIDDEN);
        return { error: { status, data: ERROR_MESSAGES.FORBIDDEN } };
      }

      // Handle 502 Bad Gateway specifically
      if (status === 502) {
        console.error("502 Bad Gateway Error: The API server is unreachable or returning an invalid response");
        return { 
          error: { 
            status, 
            data: "The server is currently unavailable. Please check your API server connection or try again later." 
          } 
        };
      }
      
      // Handle other 500 Server Errors
      if (status >= 500) {
        console.error(ERROR_MESSAGES.SERVER_ERROR);
        return { error: { status, data: ERROR_MESSAGES.SERVER_ERROR } };
      }
    }

    return result;
  } catch (error) {
    // Handle network errors
    console.error(ERROR_MESSAGES.NETWORK_ERROR, error);
    return {
      error: { status: "FETCH_ERROR", data: ERROR_MESSAGES.NETWORK_ERROR },
    };
  }
};
